// Module
var code = "<svg id=\"add_black_24dp\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\">\n  <path id=\"Path_7562\" data-name=\"Path 7562\" d=\"M0,0H24V24H0Z\" fill=\"none\"/>\n  <path id=\"Path_7563\" data-name=\"Path 7563\" d=\"M19,13H13v6H11V13H5V11h6V5h2v6h6Z\" fill=\"#fff\"/>\n</svg>\n";
// Exports
module.exports = code;